import React from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Input } from 'components/ui'

const KBMockupDialog = ({
    isOpen,
    onClose,
    onGenerate,
    isGenerating,
    sourceLabel,
    sourcePreview,
    resultHtml,
    error,
}) => {
    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            width={960}
            contentClassName="pb-0 px-0"
        >
            <div className="px-6 pb-6 pt-5 space-y-4">
                <div>
                    <h5>Knowledge Base Mockup</h5>
                    <p className="text-sm text-gray-500 mt-1">
                        Generates a structured KB HTML mockup from {sourceLabel || 'provided context'}.
                    </p>
                </div>

                <div className="space-y-2">
                    <p className="text-sm font-semibold">Source Context</p>
                    <Input
                        textArea
                        rows={8}
                        value={sourcePreview || ''}
                        readOnly
                    />
                </div>

                <div className="space-y-2">
                    <p className="text-sm font-semibold">Generated HTML</p>
                    <Input
                        textArea
                        rows={10}
                        value={resultHtml || ''}
                        readOnly
                    />
                </div>

                {error ? <p className="text-sm text-red-500">{error}</p> : null}
            </div>

            <div className="text-right px-6 py-3 bg-gray-100 dark:bg-gray-700 rounded-bl-lg rounded-br-lg">
                <Button
                    size="sm"
                    className="ltr:mr-2 rtl:ml-2"
                    onClick={onClose}
                >
                    Close
                </Button>
                <Button
                    size="sm"
                    variant="solid"
                    onClick={onGenerate}
                    loading={isGenerating}
                >
                    Regenerate
                </Button>
            </div>
        </Dialog>
    )
}

KBMockupDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onGenerate: PropTypes.func,
    isGenerating: PropTypes.bool,
    sourceLabel: PropTypes.string,
    sourcePreview: PropTypes.string,
    resultHtml: PropTypes.string,
    error: PropTypes.string,
}

KBMockupDialog.defaultProps = {
    isOpen: false,
    isGenerating: false,
    sourceLabel: 'context',
    sourcePreview: '',
    resultHtml: '',
    error: '',
}

export default KBMockupDialog
